'use client'
import useScreenWidth from '@/hooks/useScreenWidth'
import { useRouter } from 'next/navigation'
import React from 'react'
import Image from 'next/image'
const Template03 = (props: any) => {
  const screenWidth = useScreenWidth()
  const router = useRouter()

  const Navigate = (link: string) => {
    router.push(link)
  }
  return (
    <>
      {props.data !== undefined && (
        <section className="offer-banner-section">
          {/* <div className="main-title-section text-center">
            <h2 className="main-title-heading">{props.data.name}</h2>
          </div> */}
          <div className="row mx-0">
            {props.data.section_items.map((item: any, itemIndex: number) => (
              <div
                className="col-md-6 offer-banner-repeat"
                key={itemIndex}
              >
                <div className="position-relative text-center">
                  {(() => {
                    const isDesktop = screenWidth > 768
                    const xPos = isDesktop ? item.desk_btn_x_position : item.mob_btn_x_position
                    const yPos = isDesktop ? item.desk_btn_y_position : item.mob_btn_y_position
                    const theme = isDesktop ? item.desk_btn_theme : item.mob_btn_theme

                    if (item.description !== '' && xPos !== null) {
                      const className = isDesktop ? 'btn bg-white p-3' : 'btn bg-white fs-14 p-3'
                      // theme === 'white'
                      //   ? 'btn btn-outline-light btn-sm'
                      //   : theme === 'black'
                      //   ? 'btn btn-outline-black btn-sm'
                      //   : 'btn btn-custom btn-sm'

                      return (
                        <button
                          className={className}
                          style={{
                            position: 'absolute',
                            left: `${xPos}%`,
                            top: `${yPos}%`,
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10
                          }}
                          onClick={() => Navigate(item.link)}
                        >
                          {item.description}
                        </button>
                      )
                    }

                    return null
                  })()}
                  {item.description !== '' ? (
                    <Image
                      src={screenWidth > 768 ? item.desktop_image : item.mobile_image}
                      alt="product"
                      width={505}
                      height={575}
                      quality={85}
                      sizes="(max-width: 768px) 100vw, (max-width: 1024px) 382px, 505px"
                      style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
                    />
                  ) : (
                    // <img
                    //   src={screenWidth > 768 ? item.desktop_image : item.mobile_image}
                    //   alt="product"
                    // />
                    <span
                      className="offer-banner-link"
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => Navigate(item.link)}
                    >
                      <Image
                        src={screenWidth > 768 ? item.desktop_image : item.mobile_image}
                        alt="product"
                        width={505}
                        height={575}
                        quality={85}
                        sizes="(max-width: 768px) 100vw, (max-width: 1024px) 382px, 505px"
                        style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
                      />
                      {/* <img
                        src={screenWidth > 768 ? item.desktop_image : item.mobile_image}
                        alt="product"
                      /> */}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </>
  )
}

export default Template03
